(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantheon-payday-sale-bar"] && !Shopify.designMode) return;
  try {
    
  const saleBars = document.querySelectorAll('[data-payday-sale-bar]');

  saleBars.forEach((bar) => {
    const timeZone = bar.dataset.countdownTimeZone || 'Europe/London';
    const days = bar.querySelector('[data-payday-days]');
    const hours = bar.querySelector('[data-payday-hours]');
    const minutes = bar.querySelector('[data-payday-minutes]');
    const seconds = bar.querySelector('[data-payday-seconds]');
    const copyButton = bar.querySelector('[data-payday-copy]');
    const copyFeedback = bar.querySelector('[data-payday-copy-feedback]');

    if (!days || !hours || !minutes || !seconds) return;

    const pad = (value) => String(value).padStart(2, '0');
    const datePartsFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const getZonedParts = (date) => {
      const parts = Object.fromEntries(
        datePartsFormatter.formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );

      return {
        year: parts.year,
        month: parts.month,
        day: parts.day,
        hour: parts.hour % 24,
        minute: parts.minute,
        second: parts.second,
      };
    };

    const getTimeZoneOffset = (date) => {
      const parts = getZonedParts(date);
      const zonedTimestamp = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

      return zonedTimestamp - date.getTime();
    };

    const zonedTimeToUtc = (year, month, day, hour, minute, second) => {
      const utcTimestamp = Date.UTC(year, month - 1, day, hour, minute, second);
      let offset = getTimeZoneOffset(new Date(utcTimestamp));
      let timestamp = utcTimestamp - offset;

      offset = getTimeZoneOffset(new Date(timestamp));
      timestamp = utcTimestamp - offset;

      return timestamp;
    };

    const getNextMidnightTimestamp = () => {
      const now = new Date();
      const today = getZonedParts(now);
      const todayNoon = zonedTimeToUtc(today.year, today.month, today.day, 12, 0, 0);
      const tomorrow = getZonedParts(new Date(todayNoon + 86400000));

      return zonedTimeToUtc(tomorrow.year, tomorrow.month, tomorrow.day, 0, 0, 0);
    };

    const update = () => {
      const now = Date.now();
      bar.hidden = false;
      const remaining = Math.max(0, getNextMidnightTimestamp() - now);
      const totalSeconds = Math.floor(remaining / 1000);

      days.textContent = pad(Math.floor(totalSeconds / 86400));
      hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    };

    update();
    setInterval(update, 1000);

    if (!copyButton || !copyFeedback) return;

    copyButton.addEventListener('click', async () => {
      const code = copyButton.dataset.discountCode;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const helper = document.createElement('textarea');
        helper.value = code;
        helper.setAttribute('readonly', '');
        helper.style.position = 'fixed';
        helper.style.opacity = '0';
        document.body.appendChild(helper);
        helper.select();
        document.execCommand('copy');
        document.body.removeChild(helper);
      }

      copyButton.classList.add('is-copied');
      copyFeedback.textContent = 'Copied';

      setTimeout(() => {
        copyButton.classList.remove('is-copied');
        copyFeedback.textContent = 'Tap to copy';
      }, 1800);
    });
  });

  const formatGbp = (value, showCurrency) =>
    new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value) + (showCurrency ? ' GBP' : '');

  const parsePrice = (text) => {
    const match = String(text || '').replace(/,/g, '').match(/£\s*([0-9]+(?:\.[0-9]{1,2})?)/);
    return match ? Number(match[1]) : null;
  };

  const applyPaydayCartPrices = () => {
    document.querySelectorAll('cart-drawer-component .cart-items__table-row').forEach((row) => {
      const priceCell = row.querySelector('.cart-items__price text-component');
      if (!priceCell) return;
      if (priceCell.dataset.paydaySaleApplied === 'true') return;

      const original = parsePrice(priceCell.getAttribute('value') || priceCell.textContent);
      if (!Number.isFinite(original) || original <= 0) return;

      const showCurrency = /GBP/.test(priceCell.textContent || priceCell.getAttribute('value') || '');
      const originalCents = Math.round(original * 100);
      const discountCents = Math.floor(originalCents * 0.2);
      const sale = (originalCents - discountCents) / 100;
      const saleText = formatGbp(sale, showCurrency);
      const originalText = formatGbp(original, showCurrency);

      priceCell.dataset.paydaySaleApplied = 'true';
      priceCell.dataset.paydayOriginalPrice = String(original);
      priceCell.setAttribute('value', saleText);
      priceCell.innerHTML = `<span class="pantheon-cart-sale-price">${saleText}</span><s class="pantheon-cart-compare-price">${originalText}</s>`;
    });
  };

  applyPaydayCartPrices();

  const cartObserver = new MutationObserver(applyPaydayCartPrices);
  cartObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  } catch(e) { console.error(e); }
})();
})();
